"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11.344 11.896h2.168V9.729h-2.168v2.168Zm8.504 1.291v3.961a.292.292 0 0 1-.292.293H6.354a.292.292 0 0 1-.206-.086l-1.98-1.982a.288.288 0 0 1 0-.41L6.15 12.98a.29.29 0 0 1 .205-.085h13.202c.161 0 .292.13.292.291Zm-6.336 9.505a.296.296 0 0 1-.292.293h-1.584a.296.296 0 0 1-.292-.293V18.44h2.168v4.252ZM1.84 8.437V3.684c0-.162.131-.292.292-.292h17.36a.29.29 0 0 1 .207.086l2.376 2.376a.294.294 0 0 1 0 .412l-2.377 2.377a.29.29 0 0 1-.206.085H2.132a.292.292 0 0 1-.292-.291Zm9.504-7.13c0-.157.134-.291.292-.291h1.584c.16 0 .292.133.292.292v1.084h-2.168V1.308Zm8.148 8.421c.346 0 .671-.134.914-.378l2.377-2.377a1.293 1.293 0 0 0 0-1.827l-2.376-2.374a1.297 1.297 0 0 0-.915-.38h-4.98V1.308c0-.712-.579-1.292-1.292-1.292h-1.584c-.712 0-1.292.58-1.292 1.292v1.084H2.132c-.712 0-1.292.58-1.292 1.292v4.752c0 .713.58 1.293 1.292 1.293h8.212v2.168H6.352c-.34 0-.672.137-.91.377l-1.98 1.98a1.285 1.285 0 0 0-.001 1.827l1.98 1.98c.24.24.573.38.913.38h3.99v4.252c0 .712.58 1.291 1.292 1.291h1.584c.713 0 1.292-.579 1.292-1.292V18.44h5.044c.713 0 1.292-.579 1.292-1.292v-3.96c0-.713-.579-1.292-1.292-1.292h-5.044V9.729h4.98Z",
    clipRule: "evenodd"
  })]
});